<template>
  <Dropdown
    tag="li"
    position="center"
    class="language-select nav-item balance languages-navbar"
  >
    <template v-slot:title>
      <a
        class="nav-link"
        href="#"
        @click.prevent
      >
        <div class="!tw-flex cont-it">
          <img
            v-if="flags[selectedLanguageCode]"
            :src="flags[selectedLanguageCode]"
            height="15"
            class="mt-2 mr-2"
            :alt="selectedLanguageCode"
          >
          <span class="pl-4 language-select__language-code">{{ selectedLanguageCode }}</span>
          <i class="fas fa-angle-down ml-4 mt-4" />
        </div>
      </a>
    </template>

    <ul class="lang__items pl-0">
      <li
        v-for="language in availableLanguages"
        :key="language.code"
        :class="{active: selectedLanguageCode === language.code}"
        class="!tw-flex !tw-justify-between"
        @click="changeLanguage(language.code)"
      >
        <div>
          <img
            v-if="flags[language.code]"
            :src="flags[language.code]"
            height="14"
            class="tw-mr-6"
            :alt="language.code"
          >
          <span
            href="#"
            class="lang__link"
          >
            {{ language.name }}
          </span>
        </div>
        <div class="checkbox mt-4" />
      </li>
    </ul>
  </Dropdown>
</template>

<script>
import deFlag from '@/assets/img/de-top.png';
import enFlag from '@/assets/img/en-top.png';
import esFlag from '@/assets/img/es-top.png';
import frFlag from '@/assets/img/fr-top.png';
import heFlag from '@/assets/img/he-top.png';
import ptFlag from '@/assets/img/pt-top.png';
import ruFlag from '@/assets/img/ru-top.png';
import trFlag from '@/assets/img/tr-top.png';
import bnFlag from '@/assets/img/bn-top.png';


export default {
  name: 'LanguageSelect',

  data() {
    return {
      selectedLanguageCode: localStorage.getItem('language') || 'en',
      availableLanguages: [],
      flags: {
        de: deFlag,
        en: enFlag,
        es: esFlag,
        fr: frFlag,
        he: heFlag,
        pt: ptFlag,
        ru: ruFlag,
        tr: trFlag,
        bn: bnFlag,
      },
    };
  },

  created() {
    this.setAvailableLanguages();
  },

  methods: {
    setAvailableLanguages() {
      this.$store.dispatch('getAvailableLanguages')
        .then((availableLanguages) => {
          this.availableLanguages = availableLanguages;
        });
    },

    changeLanguage(code) {
      this.selectedLanguageCode = code;
      this.$locale.value = code;
    },
  },

};
</script>

<style lang="scss">
.language-select {
  &__language-code {
    font-size: 14px;
    font-weight: 600;
    color: #2c2c2c !important;
    text-transform: uppercase;
  }
}
</style>
